module.exports = __webpack_public_path__ + "img/LOGO COFFEE BOX (1).3e7b7441.png";